import { Extension } from '@tiptap/core';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        nonBreakingSpace: {
            /**
             * Toggle a non-breaking space
             * @example editor.commands.toggleNonBreakingSpace()
             */
            toggleNonBreakingSpace: () => ReturnType;
        };
    }
}

export const NonBreakingSpace = Extension.create({
    name: 'nonBreakingSpace',
    addCommands() {
        return {
            toggleNonBreakingSpace:
                () =>
                ({ tr, state, dispatch }) => {
                    const { from, to, empty } = state.selection;
                    const nonBreakingSpace = '\u00A0';

                    if (empty) {
                        dispatch?.(tr.insertText(nonBreakingSpace, from, to));
                        return true;
                    }

                    let selectedText = state.doc.textBetween(from, to);

                    if (selectedText.includes(nonBreakingSpace)) {
                        selectedText = selectedText.replace(new RegExp(nonBreakingSpace, 'g'), ' ');
                    } else {
                        selectedText = selectedText.replace(/ /g, nonBreakingSpace);
                    }

                    dispatch?.(tr.insertText(selectedText, from, to));

                    return true;
                },
        };
    },

    addKeyboardShortcuts() {
        return {
            'Mod+Shift+Space': () => this.editor.commands.toggleNonBreakingSpace(),
        };
    },
});
